import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ConditionEditorContext, ConditionEditorContextConsumer, ConditionEntry } from '@sdbn/common-extended';
import { Subject } from 'rxjs';

@Component({
  selector: 'yard-carrier-condition-editor',
  standalone: false,
  templateUrl: './carrier-condition-editor.component.html',
  styleUrl: './carrier-condition-editor.component.scss',
})
export class CarrierConditionEditorComponent implements OnInit,  ConditionEditorContextConsumer {

  condition: ConditionEntry;

  formGroup = new FormGroup({
    name: new FormControl(null, [])
  });

  setConditionEditorContext(context: ConditionEditorContext): void {
    context.selectedCondition.subscribe(
      condition => {
        this.condition = condition;
        this.formGroup.patchValue({ name: condition.data });
      }
    );
  }

  setChangedSubject(changed: Subject<void>): void {
  }

  ngOnInit(): void {
    this.formGroup.valueChanges.subscribe(value => {
      this.condition.data = value.name;
    });
  }

}
